<template>
  <about-me-skeleton v-if="aboutMeLoading"></about-me-skeleton>
  <v-content id="aboutMeContent" v-else>
    
    <v-container class="color1 pageHeader">
      <v-row>
        <v-col cols="12">
          <div class="text-center align-end justify-end">
            <h1 class="display-1">{{ $t("aboutMe") }}</h1>
          </div>
        </v-col>
      </v-row>
    </v-container>
    
    <v-container>
      <v-row class="white anchor--text">
        <v-col cols="12" sm="5">
          <div class="text-center text-md-left">
            <v-img
              :src="getHeader.image"
              contain
              max-height="150px"
              :position="getPhotoPosition"
              transition="slide-y-transition"
            ></v-img>
          </div>
        </v-col>
        <v-col cols="12" sm="7">
          <div class="text-center text-md-left">
            <h1 class="display-1 bold">{{ tl(getHeader.name) }}</h1>
            <h4 class="subtitle-1">{{ tl(getHeader.academicTitle) }}</h4>
            <h4 class="subtitle-1">{{ tl(getHeader.position) }}</h4>
            <p></p>
            <p class="body-1">
              <v-icon left color="black">mdi-email</v-icon>rashmee.rajkarnikar@gmail.com
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row class="color5 background--text cardRow">
        <v-col cols="12">
          <div class="text-center">
            <h2>
              <b>{{ $t("academicQualifications") }}</b>
            </h2>
          </div>
          <v-timeline :dense="isTimelineDense">
            <v-timeline-item
              color="background"
              icon-color="black"
              icon="mdi-school"
              fill-dot
              class="timelineItem"
              v-for="(academics, idx) in getAcademics"
              :key="idx"
            >
              <v-card tile>
                <v-container pa-0>
                  <v-row class="cardRow">
                    <v-col cols="12">
                      <div :class="getTimelineItemTextClass(idx)">
                        <h3>
                          <b>{{ tl(academics.degree) }}</b>
                        </h3>
                        <p class="body-1 pText" mb-1>{{ tl(academics.date) }}</p>
                        <p class="body-1 pText">
                          <a
                            target="_blank"
                            :href="getLink(academics.from)"
                          >{{ tl(academics.from) }}</a>
                        </p>
                        <p class="body-1 pText">
                          <b>
                            <i>{{ academics.thesis.title }}</i>
                          </b>
                          <v-btn 
                            v-if="'link' in academics.thesis" 
                            text 
                            color="blue" 
                            @click="gotoRoute(academics.thesis.link)"
                          >
                            <v-icon>mdi-link</v-icon>
                            <span>{{ $t("view") }}</span>
                          </v-btn>
                        </p>
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-center">
            <h2>
              <b>{{ tl(getPublications.title) }}</b>
            </h2>
          </div>
          <v-row>
            <v-container>
              <v-row class="publicationRow">
                <div class="text-left">
                  <h3>
                    <b><u>{{ tl(getPublications.buddhism.title) }}</u></b>
                  </h3>
                </div>
              </v-row>
              <br>
              <v-row class="publicationRow">
                <ol>
                  <li v-for="(article, idx) in getPublications.buddhism.articles" :key="idx">
                    <p>
                      <span v-html="article.title"></span>
                      <v-btn
                        v-if="article.link != ''" 
                        text 
                        color="blue"
                        @click="gotoArticle(article.link)"
                      >
                        <v-icon>mdi-link</v-icon>
                        <span>{{ $t("view") }}</span>
                      </v-btn>
                    </p>
                  </li>
                </ol>
              </v-row>
            </v-container>
          </v-row>
          <v-row>
            <v-container>
              <v-row class="publicationRow">
                <div class="text-left">
                  <h3>
                    <b><u>{{ tl(getPublications.economics.title) }}</u></b>
                  </h3>
                </div>
              </v-row>
              <br>
              <v-row class="publicationRow">
                <ol>
                  <li v-for="(article, idx) in getPublications.economics.articles" :key="idx">
                    <p>
                      <span v-html="article.title"></span>
                      <v-btn
                        v-if="article.link != ''" 
                        text 
                        color="blue"
                        @click="gotoArticle(article.link)"
                      >
                        <v-icon>mdi-link</v-icon>
                        <span>{{ $t("view") }}</span>
                      </v-btn>
                    </p>
                  </li>
                </ol>
              </v-row>
            </v-container>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

  </v-content>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AboutMeSkeleton from "@/components/aboutMe/AboutMeSkeleton.vue";

export default {
  name: "AboutMe",
  components: {
    aboutMeSkeleton: AboutMeSkeleton
  },
  computed: {
    ...mapGetters([
      "getWindowWidth",
      "getHeader",
      "getCurrentPosition",
      "getAcademics",
      "getPublications",
      "aboutMeLoading"
    ]),
    getPhotoPosition() {
      if (this.getWindowWidth <= 750) {
        return "center center";
      }
      return "center right";
    },
    isTimelineDense() {
      if (this.getWindowWidth <= 1250) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(["fetchAboutMeData"]),
    getLink(obj) {
      if (obj) {
        if ("link" in obj) {
          return obj.link;
        }
      }
      return "";
    },
    getTimelineItemTextClass(idx) {
      if (idx % 2 == 0) {
        return "text-left";
      } else {
        if (this.getWindowWidth <= 1250) {
          return "text-left";
        }
        return "text-right";
      }
    },
    gotoRoute(link) {
      this.$router.push({
        name: "workTopic",
        params: {
          id: link
        }
      });
      this.logEvent("button_click", {
        name: "thesisView",
        page: "aboutMe",
        link: link
      });
    },
    gotoArticle(link, article) {
      this.logEvent("button_click", {
        name: "articleView",
        "page": "aboutMe",
        link: link,
        article: article 
      })  

      if (link.includes("http")) {
        window.open(link, "_blank")
      } else {
        this.$router.push({
          name: "workTopic",
          params: {
            id: link
          }
        })
      }
    }
  },
  beforeMount() {
    this.fetchAboutMeData();
  },
  mounted() {
    this.logEvent("page_load", { 
      pageName: "aboutMe",
      lang: this.$i18n.locale
     });
  },
  metaInfo() {
    return {
      title: "Dr. Rashmee Rajkarnikar - About Me",
      meta: [
        {
          name: "description",
          content: "About Dr. Rashmee Rajkarnikar, sometimes also referred to as Rashmi Shilpakar (Rajkarnikar). Dr. Rashmee is a Ph.D. holder in Economics having completed her doctorate degree from Tribhuvan Universtiy of Nepal. She is currently working as an assistant professor in Tribhuvan University."
        },
        {
          property: "og:title",
          content: "About Dr. Rashmee Rajkarnikar"
        },
        {
          property: "og:site_name",
          content: "Dr. Rashmee Rajkarnikar - About Me"
        },
        {
          property: "og:description",
          content: "Ph.D. holder in Economics. Assistant Professor in Tribuvan University of Nepal."
        },
        {
          property: "og:type",
          content: "biography"
        },
        {
          property: "og:url",
          content: "https://dr-rashmee.com/en/aboutMe"
        },
        {
          property: "og:image",
          content: "https://firebasestorage.googleapis.com/v0/b/newecohelp.appspot.com/o/aboutMe%2Frashmee.jpg?alt=media&token=026c4ef9-ed03-4ea9-8d57-060796352a88"
        }
      ]
    }
  }
};
</script>

<style scoped>
.pageHeader {
  margin: 0;
  padding: 0;
  min-width: 100%;
  min-height: 100px;
}
#aboutMeContent {
  padding: 0 !important;
}
#aboutMeCard {
  width: 80%;
  align-self: auto !important;
}
.cardRow {
  margin: 0;
}
.cardRowDiv {
  margin: 10px;
}
.publicationRow {
  margin-left: 20px;
  margin-right: 20px;
}
.timelineItem {
  padding-bottom: 5px;
}
.pText {
  margin-bottom: 0;
}
</style>